<template>
    <div :class="(userOnboardingPerPageName !== 'dashboard') ? 'vue-onboarding__actions' : 'vue-onboarding__actions_per_page'">
        <v-button-group v-if="userOnboardingPerPageName !== 'dashboard'">
            <Button
                v-if="actions.includes('previousStep')"
                type="outlined"
                color="grey"
                class="vue-onboarding__actions__prev flex-1"
                @click="onPrevious">Quay lại</Button>
            <Button 
                v-if="actions.includes('nextStep')" 
                class="vue-onboarding__actions__next flex-1"
                @click="onNext">Tiếp tục</Button >
        </v-button-group>

        <v-button-group v-else>
            <Button
                v-if="actions.includes('exit')"
                type="flat"
                color="white"
                class="vue-onboarding__actions__prev flex-1"
                @click="onExitPerPage">{{ $t('home.userOnboarding.btnStep.btnExit') }}</Button>
            <Button 
                v-if="actions.includes('nextStep')"
                type="outlined"
                color="white" 
                class="vue-onboarding__actions__next flex-1 rounded"
                @click="onNextPerPage">{{ $t('home.userOnboarding.btnStep.btnContinue') }}</Button >            
        </v-button-group>

        <div class="flex justify-end" v-if="actions.includes('finish')">
            <Button class="w-1/2 pointer-events-none"></Button>
            <Button 
                v-if="actions.includes('finish')" 
                type="filled"
                color="white"
                class="vue-onboarding__actions__next flex-1 text-primary w-1/2"
                @click="onFinishPerPage">{{ $t('home.userOnboarding.btnStep.btnFinish') }}</Button >
        </div>
        <div v-else>
        </div>
    </div>
</template>

<script>
import VButtonGroup from "../Button/VButtonGroup.vue";
import Button from "../Button/Button.vue";

export default {
    name: "vue-onboarding-actions",

    components: { VButtonGroup, Button },

    props: {
        /** nextStep, previousStep, skip, finish */
        actions: {
            type: Array,
            default: [],
        },

        userOnboardingPerPageName: {
            type: String,
            default: ''
        }        

        // @emit
        // $emit('next')
        // $emit('previous')
    },

    data() {
        return {};
    },

    methods: {
        onNext() {
            this.$emit("next");
        },

        onPrevious() {
            this.$emit("previous");
        },

        onExitPerPage() {
            this.$emit("onExitPerPage");
        },

        onNextPerPage() {
            this.$emit("onNextPerPage");
        },

        onFinishPerPage() {
            this.$emit("onFinishPerPage");
        }
    },
};
</script>

<style lang="scss">
$secondary: #6C757D;

.vue-onboarding__actions {
    padding: 0 16px 16px;

    .vue-onboarding__actions__prev {
        color: $secondary !important;
        border-color: $secondary !important;
    }
}

.vue-onboarding__actions_per_page {
    padding: 0 16px 16px;
    background: #DA2D8A;
    border-radius: 0px 0px 6px 6px;
    border-left: 1px solid #F3F2F7;
    border-right: 1px solid #F3F2F7;
    border-bottom: 1px solid #F3F2F7;
}


</style>



// WEBPACK FOOTER //
// src/components/VueOnboarding/VueOnboardingActions.vue